export default {
  haversineDistance: ([lat1, lon1], [lat2, lon2]) => {
    const toRadian = angle => (Math.PI / 180) * angle
    const distance = (a, b) => (Math.PI / 180) * (a - b)
    const RADIUS_OF_EARTH_IN_KM = 6371

    const dLat = distance(lat2, lat1)
    const dLon = distance(lon2, lon1)

    lat1 = toRadian(lat1)
    lat2 = toRadian(lat2)

    // Haversine Formula
    const a = Math.sin(dLat / 2) ** 2 + Math.sin(dLon / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2)
    const c = 2 * Math.asin(Math.sqrt(a))

    const finalDistance = RADIUS_OF_EARTH_IN_KM * c

    return Math.round(finalDistance)
  },
  googleMapUrlForTwoLocationsDirections: ([latOrigin, lngOrigin], [latDest, lngDest]) => {
    return (
      `https://www.google.com/maps/embed/v1/directions?key=AIzaSyDoQTYALbYv9-4-8IJ7fXbQ0WBKV5vKDQ4&` +
      `origin=${latOrigin},${lngOrigin}` +
      `&destination=${latDest},${lngDest}`
    )
  }
}
